import { vp } from "./vp";
import { DataUtils } from "../libs/utils/DataUtils";
import { DomSelectorUtils } from "../libs/utils/DomSelectorUtils";
export class ComponentManager {
    constructor() {
        this._components = {};
        this._componentByID = {};
        this._requestComponentsList = [];
    }
    pushQueue(jsName, ComponentClass) {
        vp.queue.push(() => {
            DomSelectorUtils.getHtmlList(jsName, document.body).forEach((element) => {
                if (!this.getByHTML(element)) {
                    this.addComponent(new ComponentClass(element));
                }
            });
        });
        return this._components[jsName];
    }
    addComponent(component) {
        if (!this._components[component.jsName]) {
            this._components[component.jsName] = [];
        }
        this._components[component.jsName].push(component);
        if (component.html.id) {
            if (!this._componentByID[component.html.id]) {
                this._componentByID[component.html.id] = component;
            }
            else {
                logger.error('2 components found with id "' + component.html.id + '". Will be ignored for ' + component.jsName);
            }
        }
        component.init();
        this._requestComponentsList.forEach((requestItem) => {
            if ((DataUtils.isNotNone(requestItem.query.jsName) && requestItem.query.jsName === component.jsName)
                || (DataUtils.isNotNone(requestItem.query.id) && requestItem.query.id === component.html.id)) {
                requestItem.callback(component);
            }
        });
    }
    static getFirstJsName(html) {
        for (let i = 0; i < html.classList.length; i++) {
            const split = html.classList.item(i).split('js_');
            if (split.length > 0) {
                return split[1];
            }
        }
        return '';
    }
    getByHTML(html, onReadyCallback = null) {
        function check(componentCheck) {
            if (componentCheck.html === html) {
                component = componentCheck;
                if (onReadyCallback) {
                    onReadyCallback(component);
                }
            }
        }
        let component = null;
        if (html.id) {
            this.forEach({ id: html.id }, (componentCheck) => {
                check(componentCheck);
            }, !!onReadyCallback);
        }
        else {
            const jsName = ComponentManager.getFirstJsName(html);
            if (jsName) {
                this.forEach({ jsName: jsName }, (componentCheck) => {
                    check(componentCheck);
                }, !!onReadyCallback);
            }
            else {
                logger.error('html is not a component.');
            }
        }
        return component;
    }
    forEach(query = null, callback, keepAlive = false) {
        if (query && (query.id || query.jsName)) {
            const requestItem = { query, callback };
            if (query.id) {
                if (this._componentByID[query.id]) {
                    requestItem.callback(this._componentByID[query.id]);
                }
            }
            else if (query.jsName) {
                if (this._components[query.jsName]) {
                    this._components[query.jsName].forEach((component) => {
                        requestItem.callback(component);
                    });
                }
            }
            if (keepAlive) {
                this._requestComponentsList.push(requestItem);
            }
        }
        else {
            if (keepAlive) {
                logger.error('cant be keepAlive');
            }
            for (let jsName in this._components) {
                this._components[jsName].forEach((component) => {
                    callback(component);
                });
            }
        }
    }
}
